import { gql } from "@apollo/client";

export const AddItmsChallan = gql`
  mutation AddItmsChallan(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $input: CreateItmsChallanInput!
  ) {
    AddItmsChallan(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateItmsChallan = gql`
  mutation UpdateItmsChallan(
    $token: String!
    $itms_challan_id: ID!
    $user_details: SubscribedUser!
    $input: UpdateItmsChallanInput!
  ) {
    UpdateItmsChallan(
      token: $token
      itms_challan_id: $itms_challan_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const ImportItmsChallan = gql`
  mutation ImportItmsChallan(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $input: ImportItmsChallanInput!
  ) {
    ImportItmsChallan(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      input: $input
    )
  }
`;
